import React from 'react'

import {EntityType} from "../../../gd/const/item"
import ModelEntity from "../../../model2/model-entity"
import Task from "../../../model2/task/task"
import Document from "../../../model2/doc/document"
import TaskTypeIcon from "../../icons/task-icon/task-icon-ui5"
import ProjectIconUI5 from "../../icons/project/project-icon-ui5"
import UserIconDeprecated from "../../icons/user/user-icon-deprecated"
import DocumentIcon from "../../icons/document/note-icon-ui5"
import {ItemIconSize} from "../../icons/@const"

// One glyph size for EVERY entity type -- the two typed icon components default
// to sizes of their own (TaskTypeIcon 13, ProjectIconUI5 14), so both are passed
// explicitly. Change it here and the task block, the glist table and the popover
// all follow.
//
// The enum member serves both prop types: ProjectIconUI5 takes ItemIconSize, and
// TaskTypeIcon's union of string literals accepts it because a string-enum member
// is assignable to its own literal type.
const ICON_SIZE = ItemIconSize.SIZE_14

type Props = {
    entity      : ModelEntity

    // Margins around the glyph. The default suits a row that has no inset of its
    // own (the glist cell); the popover passes its own, because `.option`
    // already opens with 20px of padding.
    className?  : string
}

// Entity icon for a related-item row. Every type renders the same ICON_SIZE glyph
// with matching margins so the flat list stays visually uniform.
export default function RelatedItemIcon(props: Props) {
    const entity    = props.entity
    const className = props.className ?? "m-l-6 m-r-6"

    const glyph = (icon: string) =>
        <div className={Classes(`ui5-ico-${ICON_SIZE}`, icon, "ui5-txt-not-important", className)}/>

    switch (entity.itemType) {
        case EntityType.TASK:
            return (
                <TaskTypeIcon
                    className={className}
                    size={ICON_SIZE}
                    taskTypeId={(entity as Task).taskTypeId || undefined}
                />
            )
        case EntityType.PROJECT:
            return (
                <ProjectIconUI5
                    className={className}
                    size={ICON_SIZE}
                    projectId={entity.id}
                />
            )
        case EntityType.USER:
            return (
                <UserIconDeprecated
                    className={className}
                    userId={entity.id}
                    size="22"
                />
            )
        case EntityType.DOCUMENT:
            return (
                <DocumentIcon
                    className={className}
                    size={ICON_SIZE}
                    document={entity as Document}
                />
            )
        case EntityType.EVENT:
            return glyph("i5-calendar-event")
        case EntityType.MEETING:
            return glyph("i5-meeting")
        case EntityType.GOAL:
            return glyph("i5-goals")
        default:
            return glyph("i5-waypoints")
    }
}
